import { Field, REPORT_GENDER_OPTIONS, SelectField, TextInput } from "./fields";
import styles from "./ReportsFilters.module.css";

export const CdmRegisterFilters = ({ filters, onFilterChange }) => (
  <div className={styles.finderLayout}>
    <div className={styles.recallGrid}>
      <SelectField
        label="Register"
        options={[
          { value: "TREATMENT", label: "CDM Treatment Programme" },
          { value: "PREVENTION", label: "Prevention Programme" },
          { value: "OCF", label: "OCF Patient Register" },
        ]}
        value={filters.registerType || "TREATMENT"}
        onChange={(v) => onFilterChange("registerType", v || "TREATMENT")}
      />
      <Field label="First Name">
        <TextInput
          value={filters.patientFirstname}
          onChange={(v) => onFilterChange("patientFirstname", v)}
          placeholder="First name"
        />
      </Field>
      <Field label="Last Name">
        <TextInput
          value={filters.patientLastname}
          onChange={(v) => onFilterChange("patientLastname", v)}
          placeholder="Last name"
        />
      </Field>
      <SelectField
        label="Gender"
        options={REPORT_GENDER_OPTIONS}
        value={filters.gender}
        onChange={(v) => onFilterChange("gender", v)}
      />
    </div>

    <div className={styles.finderNote}>
      <p style={{ margin: "0 0 12px", fontWeight: 600 }}>
        CDM Register — the roll of patients for the selected register.
      </p>
      <p style={{ margin: 0 }}>
        <strong>Treatment</strong> and <strong>Prevention</strong> list every
        patient registered on that programme. The <strong>OCF Patient
        Register</strong> lists patients who have had an OCF but are{" "}
        <em>not</em> on the Treatment or Prevention Programme, with their last
        OCF date.
      </p>
    </div>
  </div>
);
